import { type LabelHTMLAttributes } from "react";

import { cn } from "@/src/lib/utils";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {}

export function Label({ className, children, ...props }: LabelProps) {
  return (
    <label className={cn("text-sm font-medium text-neutral-700", className)} {...props}>
      {children}
    </label>
  );
}
